import { render } from "./PpcV2Filters.vue?vue&type=template&id=c1e5f938"
import script from "./PpcV2Filters.vue?vue&type=script&lang=js"
export * from "./PpcV2Filters.vue?vue&type=script&lang=js"

import "./PpcV2Filters.vue?vue&type=style&index=0&id=c1e5f938&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__